<template>
  <div v-if="openId || accessToken" class="box">
    <router-view />
  </div>
  <div v-else class="huitu_position">
    <img src="./assets/imageIntegral/route_nodata_up.png" alt="" class="app_img">
    <img src="./assets/imageIntegral/route_nodata_down.png" alt="" class="app_img_bm">
  </div>
</template>

<script>

import { reactive, toRefs, defineComponent, watchEffect, onMounted, onUnmounted } from 'vue';
import { getReadOnlyPresignedUrl } from '@/utils/api'
import { useRouter } from 'vue-router';
import { useStore } from "vuex";
import request from "@/utils/request";
export default defineComponent({
  name: 'App',
  setup(){ 
    const router = useRouter()
    const store = useStore();
    // const ExaminationVisible = ref(store.getters.examinationVisible)
    // const Examreslutvisible = ref(store.getters.examreslutvisible)
    const data = reactive({
      openId: '',
      accessToken: '',
      timer: null,
    })
    onMounted(() => {
      window.getReadOnlyPresignedUrlApi = (url) => {
        // eslint-disable-next-line no-async-promise-executor
        return new Promise(async(resolve, reject) => {
          const res =  await request('post', getReadOnlyPresignedUrl, {url: url})
          console.log(res, 'res');
          if(res.code === 0){
            resolve(res.data.url)
          }else{
            reject('请求出错', res.msg)
          }
        })
      }
    })
    onUnmounted(() => {
      clearInterval(data.timer)
    })
    watchEffect(()=>{
      data.openId = store.getters.userInfo
      data.accessToken = store.getters.accessToken
      window.console.log(store.getters.userInfo);
    })
    watchEffect(()=>{
      if (store.getters.userInfo) {
        window.aegis && window.aegis.setConfig({
          uin: store.getters.userInfo,
        })
      }
    })
    window.onShowBackDialog = () => {
      console.log('调用 onShowBackDialog_Success');
      if(window.location.pathname.includes('examination')){
        if(store.getters.examinationData.showPreview) return
        if(!window.location.search.includes('examBtnTitle')){
          store.dispatch('setExaminationVisible', true)
        }else if(window.location.search.includes('examBtnTitle')){
          window.history.go(-1)
        }
        // ExaminationVisible.value = true
      }else if(window.location.pathname.includes('examreslut')){
        // Examreslutvisible.value = true
        store.dispatch('setExamreslutvisible', true)
      }else if(window.location.pathname.includes('examHelpPage')){
        // Examreslutvisible.value = true
        router.push({
          path: '/examination',
          query: {
            examId: store.state.examId,
            previewBtn: store.state.previewBtn
          }
        })
      }
      // else if(window.location.pathname.includes('message_appear_history')){
      //   window.location.pathname = '/message'
      // }else if(window.location.pathname.includes('message_appear_detail')){
      //   store.dispatch('setMessageAppearDetailVisble', true)
      // }
      // else if(window.location.pathname.includes('message_appear_type')){
      // }
    }
    return{
      ...toRefs(data),
      // ExaminationVisible,
      // Examreslutvisible
    }
  },
})
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  /* border: 0; */
  /* 移动端一定要设置核心模型计算方式为border-box 防止边框padding撑大盒子 出现横向滚动条
  因为移动端禁止出现横向滚动条 */
  box-sizing: border-box;
  /* 去掉移动端能过点击元素的高亮颜色 改成透明就去掉了  只有当按住了才有 */
  -webkit-tap-highlight-color: transparent;
	user-select:none;
}
html,body,#app{
  min-height:100%;
  background-color: #F6F9FF;
}
input, textarea{
	user-select:auto;
}
#app>.height100 {
  min-height: 100%;
}
@keyframes img_c3{
  10%,
  90%{
    transform: translate3d(0, -1px, 0);
  }
  20%,
  80%{
    transform: translate3d(0, 2px, 0);
  }
  30%,
  70%
  {
    transform: translate3d(0, 5px, 0);
  }
  40%,
  60%{
    transform: translate3d(0, 8px, 0);
  }
  50%{
    transform: translate3d(0, 10px, 0);
  }
}
.img_box{
  position: relative;
}
.huitu_position{
  width: 150px;
  height: 150px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%,-50%);
}
.app_img{
  transform: translate3d(0, 0, 0);
  animation: img_c3 1s infinite;
}
.app_img_bm{
  position: absolute;
  bottom: 0;
  left: 0;
}
.box{
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}
</style>
